import { type NodeViewProps, NodeViewWrapper } from "@tiptap/react";
import type { ComponentPropsWithoutRef } from "react";
import { normalizeReferenceLabel, ReferenceChip } from "@/components/ui/reference-chip";
import { parseMentionVersionRef } from "@/lib/message-mention-link";
import { referenceTargetKindFromVersionIntent, useReferencePresentation } from "../../mentions";

function InlineNodeViewWrapper(props: ComponentPropsWithoutRef<"span">) {
  return <NodeViewWrapper as="span" {...props} />;
}

function readStringAttr(value: unknown): string | null {
  return typeof value === "string" && value.length > 0 ? value : null;
}

export function MentionReferenceNodeView({ node }: NodeViewProps) {
  const id = readStringAttr(node.attrs.id);
  const mentionType = readStringAttr(node.attrs.mentionType);
  const label = normalizeReferenceLabel(
    readStringAttr(node.attrs.label) ?? readStringAttr(node.attrs.id) ?? ""
  );
  const versionRef = readStringAttr(node.attrs.versionRef);
  const targetKind = referenceTargetKindFromVersionIntent(parseMentionVersionRef(versionRef));
  const presentation = useReferencePresentation({
    kind: "mention",
    mentionType: mentionType ?? undefined,
    targetKind,
  });

  return (
    <ReferenceChip
      as={InlineNodeViewWrapper}
      label={label}
      icon={presentation.Icon}
      interactive={false}
      referenceKind="mention"
      targetKind={targetKind ?? null}
      contentEditable={false}
      data-type="mention"
      data-id={id ?? undefined}
      data-label={label || undefined}
      data-mention-id={id ?? undefined}
      data-mention-type={mentionType ?? undefined}
      data-mention-version-ref={versionRef ?? undefined}
    />
  );
}
